import {
    APPLICATION_SCOPE_TYPE,
    ITCIAppFeatureService,
    ITCIApplication,
    ITCIApplicationAuth,
    ITCIApplicationCreateOption,
    ITCIConnection,
    ITCIFile,
    ITCITenantComponentInput,
    ITCITenantComponentOptions,
    ITCITenantComponentOutput,
    ITCIUserInfo,
    TCI_AGENT_CREATE_TYPE,
    TCI_AGENT_TYPE,
    TCI_SECURITY_TYPE,
    TCI_TOOLS_ENV_TYPE,
    TCITenantAppType,
    TCITenantSelectorType,
    ITCIEnvVars
} from "@tci/common";
import {EventEmitter, Injector} from "@angular/core";
import {Observable} from "rxjs";

// tslint:disable:no-empty-interface

export abstract class TCITenantComponentInput implements ITCITenantComponentInput {
    /**
     * TCI tenant app type
     */
    tenantAppType?: TCITenantAppType;

    /**
     * route to the module  e.g. e.g. wi-studio/client/app/flowslist/flowsList.module
     */
    moduleRoute?: string;
    /**
     * Module class name  e.g. FlowsListModule
     */
    moduleClass?: string;
    /**
     * component selector without the html tag delimiters e.g. app-create
     */
    componentSelector?: TCITenantSelectorType;
    /**
     * Mode in which this component is being launched
     */
    mode?: string;
    /**
     * marketplace tags
     */
    mkTags?: string[];
}

export abstract class TCITenantComponentOutput<E> extends EventEmitter<E> implements ITCITenantComponentOutput<E> {
}

/*************************************************************************************************/
/*                            App List Mini Detail Component Input                               */

/*************************************************************************************************/
export interface ITCIAppListMiniDetailInput extends TCITenantComponentInput {
}

export interface ITCIAppListMiniDetailOutput<T> extends ITCITenantComponentOutput<T> {
}

/*************************************************************************************************/
/*                            App Detail Menu Input                                              */
/*************************************************************************************************/
// export interface ITCIAppDetailsMenuInput extends ITCIMenuInput {
//     /**
//      * Application being used by Menu
//      */
//     getApplication(): ITCIApplication;
//
//     /**
//      * Auth function
//      * @param scope
//      */
//     getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth>;
//
//     /**
//      * get user info
//      */
//     getUserInfo(): Observable<ITCIUserInfo>;
// }

// export class BaseAppDetailMenuComponentInput extends TCITenantComponentInput implements ITCIAppDetailsMenuInput {
//     constructor(private application: ITCIApplication, private userService: NgUserService) {
//         super();
//     }
//
//     getApplication(): ITCIApplication {
//         return this.application;
//     }
//
//     getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth> {
//         return this.userService.getAuthForFunction(scope);
//     }
//
//     getUserInfo(): Observable<ITCIUserInfo> {
//         return this.userService.getUserInfo(false);
//     }
//
// }

/*************************************************************************************************/
/*                            App Create Component I/O                                           */

/*************************************************************************************************/
/**
 * interface ITCICreateAppComponentInput
 */
export interface ITCICreateAppComponentInput extends ITCITenantComponentInput {
    /**
     * Get the component create option
     */
    getCreateOption(): ITCIApplicationCreateOption;
}

/**
 * interface ITCICreateAppComponentOutput
 */
export interface ITCICreateAppComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/**
 * TCI Create Application "Upload File" and "API Selector"
 */

/**
 * Upload File
 */
export interface ITCIUploadSupportedFile {
    extension: string;
    finalFileName: string;
    optional?: boolean;
    isBinary?: boolean;
    encoding?: string;
}

export interface ITCIUploadFileCheckResult {
    type: string;
    fileContent: ITCIFile;
    name: string;
    error: boolean;
    errorMsg: string;
}

/**
 * interface ITCIUploadComponentInput
 */
export interface ITCIUploadComponentInput extends ITCITenantComponentInput {
}

export interface ITCIUploadComponentDroppedFilesOutput extends ITCITenantComponentOutput<ITCIUploadFileCheckResult | any> {
}

/**
 * interface ITCIApiChooserInput
 */
export interface ITCIApiChooserInput extends ITCITenantComponentInput {
}

export interface ITCIApiChooserOutput extends ITCITenantComponentOutput<number> {
}

/*************************************************************************************************/
/*                            App details Menu I/O                                              */

/*************************************************************************************************/
/**
 * interface for App detail menu items
 */
export interface ITCIAppDetailsMenuInput extends ITCITenantComponentInput {
    /**
     * TCI Application
     */
    application: ITCIApplication;

    /**
     * Left Submenu Route Id if present
     */
    subMenuLeftRouteId?: string;

    /**
     * Auth function
     * @param scope
     */
    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth>;

    /**
     * get user info
     */
    getUserInfo(): Observable<ITCIUserInfo>;

    /**
     * Get App Feature Toggle Service
     */
    getFeatureToggleService(): ITCIAppFeatureService;

    /**
     * Get Env var
     */
     getEnvVar(injector: Injector, ...envVarNames: string[]): Observable<ITCIEnvVars<any>>;
}

export interface ITCIAppDetailsMenuOutput {
    closeModal?: boolean;
    refresh?: boolean;
    menuItemSelector?: TCITenantSelectorType;
    result?: any;
}

/*************************************************************************************************/
/*                            App details Component Resolver Input                               */

/*************************************************************************************************/
export interface IAppDetailsComponentResolverInput extends ITCITenantComponentInput {
    getAppId(): string;

    getTenantAppType(): TCITenantAppType;
}

/*************************************************************************************************/
/*                            App details Live Stats I/O                                         */

/*************************************************************************************************/
/**
 * interface ITCIAppDetailsLiveStatsComponentInput
 */
export interface ITCIAppDetailsLiveStatsComponentInput extends ITCIAppDetailsMenuInput {

}

/**
 * interface ITCIAppDetailsLiveStatsComponentOutput
 */
export interface ITCIAppDetailsLiveStatsComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/*************************************************************************************************/
/*                            App details User TimeStamp                                        */

/*************************************************************************************************/
/**
 * interface ITCIAppDetailsUserTimestampComponentInput
 */
export interface ITCIAppDetailsUserTimestampComponentInput extends ITCIAppDetailsMenuInput {
}

/**
 * interface ITCIAppDetailsUserTimestampComponentOutput
 */
export interface ITCIAppDetailsUserTimestampComponentOutput extends ITCIAppDetailsMenuOutput {
}

/*************************************************************************************************/
/*                            Connection Delete Modal Dialog                                     */

/*************************************************************************************************/
/**
 * interface ITCIConnectionDeleteComponentInput
 */
export interface ITCIConnectionDeleteComponentInput extends ITCITenantComponentInput {
}

/**
 * interface ITCIConnectionDeleteComponentOutput
 */
export interface ITCIConnectionDeleteComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/*************************************************************************************************/
/*                            App details Hambuger Menu I/O                                      */

/*************************************************************************************************/
/**
 * interface ITCIAppDetailMenuCopyComponentInput
 */
export interface ITCIAppDetailMenuCopyComponentInput extends ITCITenantComponentInput {
}

/**
 * interface ITCIAppDetailMenuCopyComponentOutput
 */
export interface ITCIAppDetailMenuCopyComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/**
 * interface ITCIAppDetailMenuRenameComponentInput
 */
export interface ITCIAppDetailMenuRenameComponentInput extends ITCITenantComponentInput {
}

/**
 * interface ITCIAppDetailMenuRenameComponentOutput
 */
export interface ITCIAppDetailMenuRenameComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/**
 * interface ITCIAppDetailMenuTransferOwnershipComponentInput
 */
export interface ITCIAppDetailMenuTransferOwnershipComponentInput extends ITCITenantComponentInput {
}

/**
 * interface ITCIAppDetailMenuTransferOwnershipComponentOutput
 */
export interface ITCIAppDetailMenuTransferOwnershipComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/**
 * interface ITCIAppDetailMenuChangeEndpointVisivilityComponentInput
 */
export interface ITCIAppDetailMenuChangeEndpointVisibilityComponentInput extends ITCITenantComponentInput {
}

/**
 * interface ITCIAppDetailMenuChangeEndpointVisivilityComponentOutput
 */
export interface ITCIAppDetailMenuChangeEndpointVisivilityComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/*************************************************************************************************/
/*                            EnvTools Dynamic Component I/O                                     */

/*************************************************************************************************/
/**
 * interface ITCIEnvToolsComponentInput
 */
export interface ITCIEnvToolsComponentInput extends ITCITenantComponentInput {
    /**
     * Returns the selected option
     */
    getOption(): ITCITenantComponentOptions<TCI_TOOLS_ENV_TYPE>;
}

/**
 * interface ITCICEnvToolsComponentOutput
 */
export interface ITCICEnvToolsComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/**
 * interface ITCIEnvToolsAgentCreateMenuInput
 */
export interface ITCIEnvToolsAgentMenuInput extends ITCITenantComponentInput {
    /**
     * This tells what was selected on the left hand side filter
     * which is either hybrid or connect
     */
    getFilterOption(): ITCITenantComponentOptions<TCI_AGENT_TYPE>;
}

/**
 * interface ITCIEnvToolsAgentCreateMenuOutput
 */
export interface ITCIEnvToolsAgentMenuOutput {
    closeModal?: boolean;
    refresh?: boolean;
}

/**
 * interface ITCIEnvToolsAgentCreateMenuInput
 */
export interface ITCIEnvToolsAgentCreateMenuInput extends ITCITenantComponentInput {
    /**
     * This tells what was selected on the left hand side filter
     * which is either hybrid or connect
     */
    getFilterOption(): ITCITenantComponentOptions<TCI_AGENT_TYPE>;

    /**
     * This tells what is the selected create option
     */
    getSelection(): ITCITenantComponentOptions<TCI_AGENT_CREATE_TYPE>;
}

/**
 * interface ITCIEnvToolsAgentCreateMenuOutput
 */
export interface ITCIEnvToolsAgentCreateMenuOutput {
    closeModal?: boolean;
    refresh?: boolean;
}

/*************************************************************************************************/
/*                            Security Dynamic Component I/O                                     */

/*************************************************************************************************/
/**
 * interface ITCISecurityComponentInput
 */
export interface ITCISecurityComponentInput extends ITCITenantComponentInput {
    /**
     * Returns the selected option
     */
    getOption(): ITCITenantComponentOptions<TCI_SECURITY_TYPE>;
}

/**
 * interface ITCISecurityComponentOutput
 */
export interface ITCISecurityComponentOutput<E> extends ITCITenantComponentOutput<E> {
}

/**
 * TCI Application Details for Tabs and Hamburger Menu Options
 */
// export interface ITCIAppDetailsMenuOutput {
//     closeModal?: boolean;
//     refresh?: boolean;
// }

export interface IAppDetailsComponentInput extends ITCITenantComponentInput {
    getAppId(): string;
}

export interface IAppDetailsComponentOutput extends ITCITenantComponentOutput<ITCIAppDetailsMenuOutput> {
}

/*************************************************************************************************/
/*                            Marketplace Component Resolver Input                               */

/*************************************************************************************************/
export interface ITCIMarketplaceComponentResolverInput extends ITCITenantComponentInput {
    getConnectorId(): string;

    getTenantAppType(): TCITenantAppType;
}

/*************************************************************************************************/
/*                            Connections Menu I/O                                              */

/*************************************************************************************************/
/**
 * interface for Connection menu items
 */
export interface ITCIConnectionsMenuInput extends ITCITenantComponentInput {
    /**
     * TCI Connection
     */
    connection: ITCIConnection;

    /**
     * Left Submenu Route Id if present
     */
    subMenuLeftRouteId?: string;

    /**
     * Auth function
     * @param scope
     */
    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth>;

    /**
     * get user info
     */
    getUserInfo(): Observable<ITCIUserInfo>;

}

export interface ITCIConnectionsMenuOutput {
    closeModal?: boolean;
    refresh?: boolean;
}

export interface ITCIAppExecHistoryListInput extends ITCITenantComponentInput {

}

export interface ITCIAppExecHistoryListOutput extends ITCITenantComponentOutput<any> {

}
